var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-checkout-step-shipping-address-street"},[(_vm.isDadataAvailable)?_c('page-checkout-step-shipping-address-street-dadata'):_c('page-checkout-step-shipping-address-street-standard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }